<!--
* @description  参数1
* @fileName  index
* @author userName
* @date 2023-12-24 16:37:44
!-->
<template>
  <div id='ClientBottom' class='ClientBottom'>
    <div class='footMain'>
        <div class="foot-left">
            <div>Solutions</div>
            <div>Company</div>
            <div>Legal</div>
        </div>
        <div class="foot-right">
            <img src="../../assets/img/client/foot/icon_map_facebook.png" width="40px" height="40px">
            <img src="../../assets/img/client/foot/icon_map_twi.png"  width="40px" height="40px">
            <img src="../../assets/img/client/foot/icon_map_3.png"  width="40px" height="40px">
            <img src="../../assets/img/client/foot/icon_map_ins.png"  width="40px" height="40px">
        </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { // 父辈向子辈传参
  },
  name: 'index',
  data () {
    return {

    }
  },
  created () { // 实例被创建之后执行代码

    },
  computed: { // 计算属性

    },
  components: { // 组件的引用

    },
  methods: { // 方法

    },
  mounted () { // 页面进入时加载内容

    },
  watch: { // 监测变化

    }
}
</script>
<style scoped lang='scss'>
.ClientBottom{
    height: 80px;
    background: #222222;
    line-height: 80px;
    .footMain{
        width: 1200px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        .foot-left{
            display: flex;
            div{
                width: 180px;
                font-size: 18px;
                font-family: D-DINExp, D-DINExp;
                font-weight: bold;
                color: #FFFFFF;
                text-align: start;
            }
        }
        .foot-right{
            display: flex;
            align-items: flex-end;
            img{
                margin-left: 24px;
            }
        }
    }
}
</style>